(function () {
  var rulesEl = document.getElementById('PurchaseLimitRules');
  if (!rulesEl) return;

  var rules;
  try {
    rules = JSON.parse(rulesEl.textContent);
  } catch (e) {
    return;
  }

  var ruleByProduct = {};
  var variantToProduct = {};
  (rules || []).forEach(function (rule) {
    if (!rule.active) return;
    ruleByProduct[rule.product_id] = rule;
    (rule.variant_ids || []).forEach(function (variantId) {
      variantToProduct[variantId] = rule.product_id;
    });
  });
  if (!Object.keys(ruleByProduct).length) return;

  function showToast(message) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 16px;border-radius:4px;font-size:14px;z-index:9999;max-width:90%;text-align:center;';
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.remove();
    }, 4000);
  }
  window.showPurchaseLimitToast = showToast;

  function persistNotice(message) {
    try { sessionStorage.setItem('purchaseLimitNotice', message); } catch (e) {}
  }

  function consumeStoredNotice() {
    try {
      var message = sessionStorage.getItem('purchaseLimitNotice');
      if (message) {
        sessionStorage.removeItem('purchaseLimitNotice');
        showToast(message);
      }
    } catch (e) {}
  }
  consumeStoredNotice();

  function cappedMessage(remaining) {
    return window.Eurus.purchase_limit_capped_html.replace('[quantity]', remaining);
  }

  function reachedMessage() {
    return window.Eurus.purchase_limit_reached;
  }

  // ---- shared cart snapshot cache, used for synchronous limit checks ----
  var cartSnapshot = [];
  var totalsByProduct = {};

  function updateCartSnapshot(cart) {
    cartSnapshot = cart.items;
    totalsByProduct = {};
    cartSnapshot.forEach(function (item) {
      totalsByProduct[item.product_id] = (totalsByProduct[item.product_id] || 0) + item.quantity;
    });
    window.PurchaseLimitCartQty = totalsByProduct;
  }

  function refreshCartSnapshot() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartSnapshot(cart);
        return cart;
      });
  }

  // ---- fake a Shopify-style 422 error response so existing add-to-cart ----
  // ---- error handling in every file shows our message with no changes ----
  function blockedResponse(message) {
    return new Response(
      JSON.stringify({ status: 422, message: message, description: message }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  function parseAddBody(options) {
    if (!options || !options.body) return null;
    if (options.body instanceof FormData) {
      var id = options.body.get('id');
      var quantity = parseInt(options.body.get('quantity'), 10) || 1;
      return { format: 'form', id: id, quantity: quantity, body: options.body };
    }
    try {
      var data = JSON.parse(options.body);
      if (data && data.items && data.items.length) {
        return { format: 'json-items', id: data.items[0].id, quantity: parseInt(data.items[0].quantity, 10) || 1, body: data };
      }
      if (data && data.id) {
        return { format: 'json-single', id: data.id, quantity: parseInt(data.quantity, 10) || 1, body: data };
      }
    } catch (e) {}
    return null;
  }

  function interceptAdd(url, options) {
    var parsed = parseAddBody(options);
    if (!parsed) return null;

    var productId = variantToProduct[parsed.id];
    if (!productId) return null;

    var rule = ruleByProduct[productId];
    var alreadyInCart = totalsByProduct[productId] || 0;
    var remaining = Math.max(0, rule.limit - rule.purchased - alreadyInCart);

    if (parsed.quantity > remaining) {
      var message = remaining > 0 ? cappedMessage(remaining) : reachedMessage();
      showToast(message);
      return Promise.resolve(blockedResponse(message));
    }

    return null;
  }

  function parseChangeBody(options) {
    if (!options || !options.body) return null;
    try {
      var data = JSON.parse(options.body);
      if (typeof data.quantity === 'undefined') return null;
      return { line: data.line, id: data.id, quantity: parseInt(data.quantity, 10) };
    } catch (e) {
      return null;
    }
  }

  function interceptChange(url, options) {
    var parsed = parseChangeBody(options);
    if (!parsed || isNaN(parsed.quantity)) return null;

    var item = null;
    if (parsed.line) {
      item = cartSnapshot[parsed.line - 1];
    } else if (parsed.id) {
      item = cartSnapshot.find(function (i) {
        return String(i.key) === String(parsed.id) || String(i.variant_id) === String(parsed.id);
      });
    }
    if (!item) return null;

    var productId = item.product_id;
    var rule = ruleByProduct[productId];
    if (!rule) return null;

    var otherLinesTotal = (totalsByProduct[productId] || 0) - item.quantity;
    var remaining = Math.max(0, rule.limit - rule.purchased - otherLinesTotal);

    if (parsed.quantity > remaining) {
      var message = remaining > 0 ? cappedMessage(remaining) : reachedMessage();
      showToast(message);
      return Promise.resolve(blockedResponse(message));
    }

    return null;
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var method = (options && options.method) || 'GET';

    if (method.toUpperCase() === 'POST' && typeof resource === 'string') {
      if (url.indexOf('cart/add') !== -1) {
        var blocked = interceptAdd(url, options);
        if (blocked) return blocked;
      } else if (url.indexOf('cart/change') !== -1) {
        var blockedChange = interceptChange(url, options);
        if (blockedChange) return blockedChange;
      }
    }

    return nativeFetch(resource, options).then(function (response) {
      if (method.toUpperCase() === 'POST' && typeof resource === 'string' &&
          (url.indexOf('cart/add') !== -1 || url.indexOf('cart/change') !== -1 || url.indexOf('cart/update') !== -1 || url.indexOf('cart/clear') !== -1)) {
        refreshCartSnapshot();
      }
      return response;
    });
  };

  // ---- reactive backstop: catches anything the interceptor above missed ----
  // ---- (direct API calls made before this script loaded, multiple tabs, etc.) ----
  var reconciling = false;

  function waitForCartIdle() {
    if (window.Alpine && Alpine.store('xCartHelper')) {
      return Alpine.store('xCartHelper').waitForCartUpdate();
    }
    return new Promise(function (resolve) {
      (function check() {
        if (!window.updatingCart) {
          resolve();
        } else {
          requestAnimationFrame(check);
        }
      })();
    });
  }

  function reconcileCart(attempt) {
    attempt = attempt || 0;
    if (reconciling || attempt > 5) return;
    reconciling = true;

    waitForCartIdle()
      .then(refreshCartSnapshot)
      .then(function (cart) {
        var offendingLine = null;
        var offendingAllowed = 0;

        for (var productId in ruleByProduct) {
          var rule = ruleByProduct[productId];
          var allowed = Math.max(0, rule.limit - rule.purchased);
          var total = totalsByProduct[productId] || 0;

          if (total > allowed) {
            offendingLine = cart.items.findIndex(function (item) {
              return String(item.product_id) === String(productId);
            });
            var offendingItem = cart.items[offendingLine];
            offendingAllowed = allowed - (total - offendingItem.quantity);
            break;
          }
        }

        if (offendingLine === null || offendingLine === -1) {
          reconciling = false;
          return;
        }

        var newQuantity = Math.max(0, offendingAllowed);

        persistNotice(window.Eurus.purchase_limit_adjusted);
        window.updatingCart = true;
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: offendingLine + 1, quantity: newQuantity })
        }).then(function () {
          try { sessionStorage.removeItem('purchaseLimitNotice'); } catch (e) {}
          showToast(window.Eurus.purchase_limit_adjusted);
          if (window.Alpine && Alpine.store('xCartHelper')) {
            Alpine.store('xCartHelper').reRenderSections();
          }
          window.updatingCart = false;
          reconciling = false;
          reconcileCart(attempt + 1);
        });
      })
      .catch(function () {
        window.updatingCart = false;
        reconciling = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshCartSnapshot();
    reconcileCart();
  });
  document.addEventListener('eurus:cart:items-changed', function () { reconcileCart(); });
  setInterval(function () { reconcileCart(); }, 5000);
})();
